(function () {
  const AIGEN_MARKER = '_aigen_';
  const BADGE_CLASS = 'aigen-badge';
  const AIGEN_IMG_CLASS = 'aigen-img';

  function isAigenImage(img) {
    const sources = [
      img.src,
      img.currentSrc,
      img.getAttribute('src'),
      img.getAttribute('srcset'),
    ].filter(Boolean);

    return sources.some((source) => source.includes(AIGEN_MARKER));
  }

  function createBadge() {
    const badge = document.createElement('div');
    badge.className = BADGE_CLASS;
    badge.textContent = 'Edited by AI';
    return badge;
  }

  function appendBadge(container) {
    if (!container || container.querySelector(`.${BADGE_CLASS}`)) return;
    container.appendChild(createBadge());
  }

  function applyGalleryLabels(root) {
    root.querySelectorAll('.product__media-list .product__media-item').forEach((mediaItem) => {
      const hasAigenImage = Array.from(mediaItem.querySelectorAll('img')).some(isAigenImage);

      if (!hasAigenImage) return;

      mediaItem.classList.add(AIGEN_IMG_CLASS);

      const mediaWrapper =
        mediaItem.querySelector('.product__modal-opener') ||
        mediaItem.querySelector('.product__media') ||
        mediaItem;

      appendBadge(mediaWrapper);
    });
  }

  function applyModalLabels(root) {
    root.querySelectorAll('.product-media-modal__content > img').forEach((img) => {
      if (!isAigenImage(img)) return;

      let wrapper = img.parentElement;

      if (wrapper.classList.contains('product-media-modal__content')) {
        const modalWrapper = document.createElement('div');
        modalWrapper.className = `${AIGEN_IMG_CLASS} ${AIGEN_IMG_CLASS}--modal`;
        wrapper.insertBefore(modalWrapper, img);
        modalWrapper.appendChild(img);
        wrapper = modalWrapper;
      } else {
        wrapper.classList.add(AIGEN_IMG_CLASS);
      }

      appendBadge(wrapper);
    });
  }

  function applyAigenLabels(root = document) {
    applyGalleryLabels(root);
    applyModalLabels(root);
  }

  function init() {
    applyAigenLabels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    applyAigenLabels(event.target);
  });
})();
